import { MatDateFormats } from "@angular/material/core";

/**
 * Enumeración que define los tipos de fecha que se pueden usar.
 * @enum {DateType}
 */
export enum DateType {
  DATE = "date",
  DATE_TIME = "date-time",
  MONTH = "month",
  MONTH_ONLY = "month-only",
  YEAR = "year",
  RANGE = "range",
  RANGE_MONTH = "range-month",
  RANGE_YEAR = "range-year",
}

/**
 * Objeto que define el formato de fecha para las fechas.
 * @const {MatDateFormats} DateMatDateFormat
 */
export const DateMatDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

/**
 * Objeto que define el formato de fecha para los meses.
 * @const {MatDateFormats} MonthMatDateFormat
 */
export const MonthMatDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

/**
 * Objeto que define el formato de fecha para los meses (only).
 * @const {MatDateFormats} MonthMatDateFormat
 */
export const MonthOnlyMatDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'MM',
  },
  display: {
    dateInput: 'MMMM',
    monthYearLabel: 'MMM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM',
  }
};

/**
 * Objeto que define el formato de fecha para los años.
 * @const {MatDateFormats} YearMatDateFormat
 */
export const YearMatDateFormat: MatDateFormats = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  }
};

/**
 * Objeto que mapea los tipos de fecha a sus respectivos formatos de fecha.
 * @const {DateFormats} DateTypes
 */
export const DateTypes: { [dateType: string]: MatDateFormats } = {
  [DateType.DATE]: DateMatDateFormat,
  [DateType.MONTH]: MonthMatDateFormat,
  [DateType.MONTH_ONLY]: MonthOnlyMatDateFormat,
  [DateType.YEAR]: YearMatDateFormat,
  [DateType.RANGE]: DateMatDateFormat,
  [DateType.RANGE_MONTH]: MonthMatDateFormat,
  [DateType.RANGE_YEAR]: YearMatDateFormat
}